import React, { Component } from 'react';

import youtube from '../images/yt_logo_rgb_light.png';
import linkedin from '../images/Logo-2C-75px-R.png';
import rss from'../images/Generic_Feed-icon.svg'

export default class Social extends React.Component {
    render() {
      return (
<div className="links">
          <a
            className="App-link"
            href="http://blogs.recneps.org"
            target="_blank"
            rel="noopener noreferrer"
          > 
            <img src={rss} alt="" className="Link-logo"/>
          </a>  
          <a
            className="App-link"
            href="https://www.linkedin.com/in/steve-spencer-9331024/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="LinkedIn" className="Link-logo"/>
          </a>          <a
            className="App-link"
            href="https://www.youtube.com/channel/UCF1WXPtDwwbX5ZDdKPpkoog"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={youtube} alt="YouTube" className="Link-logo"/>
          </a>       
          </div>      );
    }
  }